import { motion, AnimatePresence } from "framer-motion";
import { ChevronDownIcon } from "lucide-react";
import { MarkdownContent } from "@/components/ui/markdown-content";
import { cn } from "@/lib/utils";

interface ScenarioPanelProps {
  scenario: string;
  collapsed: boolean;
  onToggle: () => void;
}

export function ScenarioPanel({
  scenario,
  collapsed,
  onToggle,
}: ScenarioPanelProps) {
  return (
    <div className="rounded-lg border border-border bg-muted/30">
      <button
        type="button"
        onClick={onToggle}
        className="flex w-full items-center justify-between px-5 py-3 text-left"
      >
        <span className="text-sm font-semibold text-muted-foreground">
          System Scenario
        </span>
        <ChevronDownIcon
          className={cn(
            "h-4 w-4 text-muted-foreground transition-transform duration-200",
            !collapsed && "rotate-180",
          )}
        />
      </button>
      <AnimatePresence initial={false}>
        {!collapsed && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.2 }}
            className="overflow-hidden"
          >
            <div className="border-t border-border px-5 py-4">
              <MarkdownContent>{scenario}</MarkdownContent>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
